<template>
  <div>
    <h2 class="section-title">{{ $t('p.clientMembersPage.title') }}</h2>

    <bar>
      <template slot="left">
        <search-input
          v-model="fetchParams.term"
          :is-loading="searchInProgress"
          @input="searchUsers"
        />
      </template>
      <template slot="right">
        <dropdown-input
          :options="sortDropdownOptions"
          :trigger-icon="sortDropdownIcon"
          @select="handleSortDropdownSelect"
        />
        <dropdown-input
          :options="roleFilterDropdownOptions"
          trigger-icon="filter"
          @select="handleRoleFilterDropdownSelect"
        />
      </template>
    </bar>

    <pagination
      v-if="meta"
      :total-items="meta.totalCount"
      :items-per-page="meta.perPage"
      :page="meta.currentPage - 1"
      :loading="isLoading"
      @page-change="handlePageChange"
    />

    <client-member
      v-for="user in users"
      :key="user.id"
      :user="user"
      @roleChange="fetch"
    />

    <no-entries-message :entries="users" />

    <pagination
      v-if="meta"
      :total-items="meta.totalCount"
      :items-per-page="meta.perPage"
      :page="meta.currentPage - 1"
      :loading="isLoading"
      @page-change="handlePageChange"
    />

    <invitation-modal />

    <button
      class="add-content-button"
      @click.prevent="openInvitationModal"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import fullName from '@/filters/fullName'
import FormMixin from '@/mixins/forms/Form'
import ClientMember from '@/components/clients/clientMember'
import InvitationModal from '@/components/invitations/InvitationModal'
import Bar from '@/components/ui/Bar'
import Pagination from '@/components/ui/pagination/pagination-base'
import NoEntriesMessage from '@/components/ui/NoEntriesMessage'

export default {
  name: 'ClientMembers',

  mixins: [FormMixin],

  components: {
    ClientMember,
    InvitationModal,
    NoEntriesMessage,
    Pagination,
    Bar
  },

  data () {
    return {
      currentFilter: 'all',
      isRoleFilterDropdownVisible: true,
      searchTerm: '',
      searchInProgress: false,
      fetchParams: {
        term: '',
        role: 'all',
        page: 1,
        sort_dir: 'asc',
        sort_by: 'first_name'
      }
    }
  },

  computed: {
    ...mapState({
      meta: state => state.users.meta,
      users: state => state.users.users,
      isLoading: state => state.users.request.isLoading
    }),

    page () {
      return this.meta.current_page - 1
    },

    sortDropdownIcon () {
      return this.fetchParams.sort_dir == 'asc' ? 'sort-amount-down' : 'sort-amount-up'
    },

    sortDropdownOptions () {
      const entries = []
      const options = ['first_name', 'email', 'memberships_count', 'created_at']
      options.forEach(option => {
        entries.push({
          active: this.fetchParams.sort_by == option,
          label: this.$t(`c.clientMember.label.${option}`),
          value: option
        })
      })

      return entries
    },

    roleFilterDropdownOptions () {
      const entries = []
      const roles = ['all', 'owner', 'admin', 'editor', 'reader']
      roles.forEach(role => {
        entries.push({
          active: this.fetchParams.role == role,
          label: this.$t(`c.clientMember.label.${role}`),
          value: role
        })
      })

      return entries
    }
  },

  methods: {
    ...mapActions([
      'openInvitationModal',
      'fetchUsers'
    ]),

    ...mapActions({
      loadingDone: 'app/loadingDone'
    }),

    fetch () {
      return this.fetchUsers(this.fetchParams)
    },

    handleSortDropdownSelect ({ value }) {
      if (this.fetchParams.sort_by == value) {
        this.fetchParams.sort_dir = this.fetchParams.sort_dir == 'asc' ? 'desc' : 'asc'
      } else {
        this.fetchParams.sort_dir = 'asc'
      }

      this.fetchParams.sort_by = value
      this.fetch()
    },

    handleRoleFilterDropdownSelect ({ value }) {
      this.fetchParams.page = 1
      this.fetchParams.role = value
      this.fetch()
    },

    searchUsers () {
      this.searchInProgress = true
      this.fetchParams.page = 1
      this.fetch().then(() => this.searchInProgress = false)
    },

    handlePageChange (page) {
      this.fetchParams.page = page
      this.fetch()
    }
  },

  created () {
    this.fetchUsers()
      .then(() => {
        this.loadingDone()
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/ClientMembersPage.vue